import { Box } from "@mui/material";
import { IS_NON_PROD } from "config/environment";

// Everything only a non-prod build shows sits inside this dashed amber outline (workspace
// AGENTS.md rule 9), so QA and the team can tell test-only information from what production
// shows. It carries no text of its own and renders nothing in production, so a gated block
// cannot leak through it. A block gated on data rather than on the build (the ABDM gateway the
// backend reports) passes `keepInProd`: there it shows without the outline, and `sx` still
// lays it out. Reuse this one component, and keep it inside the same condition as the content.

const AMBER = "#F59E0B";

const TITLE = "Not shown in production";

// `sx` for the frame inside a MUI Dialog: Paper is a flex column and DialogContent scrolls
// because of it, so the frame between them has to be one too.
export const SANDBOX_DIALOG_SX = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  alignItems: "stretch",
  flex: "1 1 auto",
  minHeight: 0,
  gap: 0,
  p: 0,
  borderRadius: "inherit",
};

const SandboxBadge = ({ children, sx, keepInProd = false }) => {
  if (!children) return null;
  if (!IS_NON_PROD) return keepInProd ? <Box sx={sx}>{children}</Box> : null;
  return (
    <Box
      role="group"
      aria-label={TITLE}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
        minWidth: 0,
        p: 0.25,
        borderRadius: "6px",
        border: `1.5px dashed ${AMBER}`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default SandboxBadge;
